import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { PennywiseAddressCardStackContentViewModel } from './pennywise-address-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-pennywise-card-stack-content',
  templateUrl: './pennywise-address-card-stack-content.component.html',
  styleUrls: ['./pennywise-address-card-stack-content.component.scss'],
  providers: [PennywiseAddressCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PennywiseAddressCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public viewModel: PennywiseAddressCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
